$( document ).ready(function() {
  $(".cstBtnhd").click(function() {
    $('html, body').animate({
      scrollTop: $(".cust-choose-bar-sec").offset().top-150
    }, 2000);
  });

  /* collection page surpise me jquery */
      var $select1 = $( '.cust_surprise_me'),
          $select2 = $( '.cust_product_form' ),
          $options = $select2.find( 'option' );
      $select1.on( 'change', function(){

        $select2.html( $options.filter( '[datavalue="' + this.value + '"]' ) );
      }).trigger( 'change' );

  
  
  var GetMainPrice = $(".cust-featured-price .price-item").html();
  console.log("GetMainPrice " + GetMainPrice);
  
    $(".cust_surprise_me").change(function(){
     var GetVal = $(this).val();
     var GetValtrim = GetVal.trim();
       console.log("GetValtrim " + GetValtrim);
      
      
      $(".cust_product_form option").each(function() {
        var GetHiddenval= $(this).attr("datavalue");
         var GetHidetrim = GetHiddenval.trim();
       console.log("GetHidetrim " + GetHidetrim);
       
        if(GetValtrim == GetHidetrim ){
         var GetPrice = $(this).attr("data-price");
          console.log("GetPrice "+ GetPrice);
          $(".cust-featured-price .price-item").html(GetPrice);
          
         // $(".cust_product_form option").trigger( 'change' );
          
         console.log("match")
         }
        else{
        console.log("not matched");
        }
        
        
      });

  });
  
  
  
  
  /* end collection page surpise me jquery */

});